export enum YesNoAnswerType {
    Yes = 'yes',
    No = 'no',
}